// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1335":"cdcf6861","2111":"5a682f81","5581":"5a682f81","9059":"5a682f81","9866":"5a682f81"}[chunkId] + ".chunk.css";
};